<template>
  <div>
    <section>
      <b-tabs
        v-model="tabIndex"
        vertical
        content-class="col-12 col-md-8 col-lg-9"
        pills
        nav-wrapper-class="faq-navigation col-md-4 col-lg-3 col-12"
        nav-class="nav-left"
      >

        <!-- Listado de materias -->
        <b-tab lazy>
          <template #title>
            <feather-icon
              icon="ListIcon"
              size="18"
              class="mr-1"
            />
            <span class="font-weight-bold">Listado de materias</span>
          </template>

          <materias />
        </b-tab>

        <!-- Nueva materia -->
        <b-tab>
          <template #title>
            <feather-icon
              icon="PlusCircleIcon"
              size="18"
              class="mr-1"
            />
            <span class="font-weight-bold">Nueva materia</span>
          </template>

          <!-- Alta de materia (steps) -->
          <edit-materia @refetch-data="tabIndex = 0" />
        </b-tab>

      </b-tabs>
    </section>

  </div>
</template>

<script>
import {
  BTabs,
  BTab,
} from 'bootstrap-vue'
import Materias from './components/edicion-materias/MateriasEdit.vue'
import EditMateria from './components/edicion-materias/components/EditMateria.vue'

export default {
  components: {
    BTabs,
    BTab,
    Materias,
    EditMateria,
  },
  data: () => ({
    tabIndex: 0,
  }),
}
</script>

<style lang="scss">
@import '@core/scss/vue/pages/page-faq.scss';
</style>
